import { useEffect } from 'react'
import './tailwind.css'
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import ErrorPage from './pages/error/ErrorPage';
import PriceCalculatorPage from './pages/priceCalculator/PriceCalculatorPage';
import CustomerGate from './components/customerGate/CustomerGate';

import { useAppDispatch, useAppSelector } from './app/hooks';
import strings, { selectLanguage, setLanguage, setLanguageToDeviceLanguageIfPossible } from './components/localize/localizeSlice';


function App() {
  const dispatch = useAppDispatch();
  useAppSelector(selectLanguage);
  
  useEffect(() => {
      dispatch(setLanguage('en'));
      dispatch(setLanguageToDeviceLanguageIfPossible())
      document.title = strings.priceCalculator
  }, []);


  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={
        window.location.hostname !== 'localhost' &&
        !window.location.hostname.startsWith('192.168.')
          ? '/html/order'
          : '/'
          }
          element={<CustomerGate><PriceCalculatorPage /></CustomerGate>}
        />
        <Route
          path={
        window.location.hostname !== 'localhost' &&
        !window.location.hostname.startsWith('192.168.')
          ? '/html/order/error'
          : '/error'
          }
          element={<ErrorPage />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
